import React from 'react';
import { Settings } from '@pascal/pascal-core/table-line';
import { observer } from 'mobx-react-lite';
import useTranslation from '../../hooks/useTranslation';
import { TranslationKeys } from '../../core/constants/translationKeys';
import { applicationStore } from '../../store/applicationStore';

export const SettingsContainer = observer(() => {
  const { isTurboMode, setIsTurboMode } = applicationStore;
  const t = useTranslation();

  return (
    <>
      <Settings />
      <div className='setting-row'>
        <div className='setting-row-column left'>
          <span className='setting-name'>{t(TranslationKeys.TurboMode)}</span>
        </div>
        <div className='setting-row-column right' onClick={() => setIsTurboMode(!isTurboMode)}>
          <div className={`switcher ${isTurboMode ? 'active' : ''}`} />
        </div>
      </div>
    </>
  );
});
